<template>
	<div class="mC-bar-box mC-bar-box1">
        <div class="mC-bar-tips">
            <div class="mC-bar-tips-word" :class="[BarTips]" :style="{ marginLeft: tipsLeft + '%' }">
                {{growthValue}}
            </div>
        </div>
        <div class="mC-bar-l-img">
            <img class="width-36" v-bind:src="leftImg">
        </div>
        <div class="mC-bg-bar" :class="[BgBar]">
            <div class="mC-bar" :class="[Bar]" :style="{ width: barWidth + '%' }">&nbsp;</div>
        </div>
        <div class="mC-bar-r-img">
            <img class="width-36" :src="rightImg">
        </div>
    </div>
</template>
<style lang="less">
    @import '../../style/variable.less';
    @import './style.less';
</style>

<script>
    module.exports = require('./index.js')
</script>